import { LoaderCircle } from 'lucide-react';
import { useEffect, useRef } from 'react';
import './history.css';

/** The end of a list that has more: the next page loads as it scrolls into view, as the mobile
 * app's lists do. Used by the history and an employee's page. */
export function LoadMore({ hasMore, loading, onMore }: { hasMore: boolean; loading: boolean; onMore: () => void }) {
  const ref = useRef<HTMLDivElement>(null);
  const more = useRef(onMore);
  useEffect(() => {
    more.current = onMore;
  });

  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore || loading || typeof IntersectionObserver === 'undefined') return;
    // Starts a little before the end, so the list rarely stops. Observing again after each page
    // keeps loading while the end stays in view.
    const io = new IntersectionObserver((seen) => seen.some((s) => s.isIntersecting) && more.current(), {
      rootMargin: '0px 0px 400px 0px',
    });
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading]);

  if (!hasMore) return null;
  return (
    <div ref={ref} className="load-more" aria-busy={loading}>
      {loading && <LoaderCircle className="spin" size={24} aria-hidden />}
    </div>
  );
}
